import React, { Fragment } from 'react';
import './style.scss';
import BulletPointListing2Item from './shared/item';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import clsx from 'clsx';
import { withTranslation } from 'react-i18next';
import GenericPlaceholder from '../Shared/components/GenericPlaceholder/index.js';

const BulletPointListing2 = (props) => {
  if (!props?.fields || !props.params) {
    return <GenericPlaceholder componentName="BulletPointListing" />;
  }
  const isSub = !!props.sub;
  const { listView, Styles, noPadding } = props?.params;
  const { items, text, separatedByDash } = props?.fields;

  const itemsPerRow = (() => {
    if (!!listView || isSub) return 1;
    if (items?.length > 3) return 3;
    return items?.length || 1;
  })();

  return (
    <div className={clsx(!isSub && 'bullet-point-listing', !noPadding && 'content', Styles)}>
      <div className="bpl-items">
        {items.map((item, index) => (
          <Fragment key={index}>
            <BulletPointListing2Item
              data={item}
              perRow={itemsPerRow}
              separatedByDash={!!separatedByDash?.value}
            />
            <div
              className={clsx(
                'bpl-items-separator',
                separatedByDash?.value && 'with-dash',
                `separator-${itemsPerRow}`,
                items?.length === index + 1 && 'd-none',
                items?.length >= 3 && (index + 1) % 3 === 0 && 'd-none',
                items?.length === 2 && index % 2 !== 0 && 'd-none',
                items?.length === 1 && 'd-none'
              )}
            >
              <div className="bpl-items-separator-text">{props?.t('OR')}</div>
            </div>
          </Fragment>
        ))}
      </div>
      {text?.value && <RichText className="bpl-text" field={text} />}
    </div>
  );
};

export default withTranslation()(BulletPointListing2);
